
  import React from 'react'
  import { MDXTag } from '@mdx-js/tag'
  

const layoutProps = {
  
};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props)
    this.layout = null
  }
  render() {
    const { components, ...props } = this.props

    return <MDXTag
             name="wrapper"
             
             components={components}><MDXTag name="h1" components={components} props={{"id":"ex-3---data-fetching"}}>{`Ex. 3 - Data Fetching`}</MDXTag>
<MDXTag name="h2" components={components} props={{"id":"instructions"}}>{`Instructions`}</MDXTag>
<MDXTag name="p" components={components}>{`Nous allons désormais récupérer les données depuis l'`}<MDXTag name="a" components={components} parentName="p" props={{"href":"https://developers.themoviedb.org/3"}}>{`API de TheMovieDB`}</MDXTag>{`. Une clef d'API a déjà été créée, nous pourrons donc nous concentrer sur la partie applicative.`}</MDXTag>
<MDXTag name="p" components={components}>{`Pour récupérer les données, nous utiliserons la librairie `}<MDXTag name="a" components={components} parentName="p" props={{"href":"https://github.com/axios/axios"}}>{`axios`}</MDXTag>{`, cela permet de faire des requêtes HTTP de façon simple et d'assurer une compatibilité sur tous les navigateurs.`}</MDXTag>
<MDXTag name="ul" components={components}>
<MDXTag name="li" components={components} parentName="ul">{`Installer `}<MDXTag name="inlineCode" components={components} parentName="li">{`axios`}</MDXTag></MDXTag>
<MDXTag name="li" components={components} parentName="ul">{`A l'aide de `}<MDXTag name="inlineCode" components={components} parentName="li">{`useEffect`}</MDXTag>{`, `}<MDXTag name="inlineCode" components={components} parentName="li">{`useState`}</MDXTag>{` et `}<MDXTag name="inlineCode" components={components} parentName="li">{`axios`}</MDXTag>{` récupérer les données depuis l'API`}</MDXTag>
</MDXTag>
<MDXTag name="h3" components={components} props={{"id":"résultat-attendu"}}>{`Résultat attendu`}</MDXTag>
<MDXTag name="p" components={components}>{`Lorsque l'utilisateur tape dans le champs de recherche, la liste de films correspondants s'affiche.`}</MDXTag>
<iframe
  src="https://codesandbox.io/embed/github/smooth-code/react-hooks-workshop/tree/end-exercise-3/?fontsize=14&view=preview"
  style={{
    width: '100%',
    height: 500,
    border: 0,
    borderRadius: 4,
    overflow: 'hidden',
  }}
  sandbox="allow-modals allow-forms allow-popups allow-scripts allow-same-origin"
/>
<MDXTag name="h2" components={components} props={{"id":"aide"}}>{`Aide`}</MDXTag>
<MDXTag name="h3" components={components} props={{"id":"utilisation-de-lapi-avec-axios"}}>{`Utilisation de l'API avec axios`}</MDXTag>
<MDXTag name="pre" components={components}><MDXTag name="code" components={components} parentName="pre" props={{"className":"language-js"}}>{`axios
  .get('https://api.themoviedb.org/3/search/movie', {
    params: {
      api_key: 'c5742978852b8f695a61e22a33a8196c',
      query: 'Lord of the Rings',
    },
  })
  .then(res => {
    console.log(res.data)
  })
`}</MDXTag></MDXTag>
<MDXTag name="h3" components={components} props={{"id":"appjs"}}>{`App.js`}</MDXTag>
<MDXTag name="pre" components={components}><MDXTag name="code" components={components} parentName="pre" props={{"className":"language-js"}}>{`// App.js
import React, { useState, useEffect } from 'react'
import { Normalize, Grid, Typography } from '@smooth-ui/core-sc'
import axios from 'axios'
import SearchInput from './components/SearchInput'

export default function App() {
  const [query, setQuery] = useState('Lord of the Rings')
  /* TODO: créer un state pour les films */

  useEffect(
    () => {
      /* TODO: faire la requête */
    },
    [
      /* TODO: spécifier les dépendances nécessaires */
    ],
  )

  return (
    <>
      <Grid py={200}>
        <Normalize />
        <Typography variant="display-1">Smooth Movie</Typography>
        <SearchInput
          value={query}
          onChange={event => setQuery(event.target.value)}
        />
        {/* TODO: afficher la liste des films */}
      </Grid>
    </>
  )
}
`}</MDXTag></MDXTag>
           </MDXTag>
  }
}
  